import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import type { PropsWithChildren } from 'react';

type AuthButtonProps = PropsWithChildren<{ loading: boolean }>;

export function AuthButton({ loading, children }: AuthButtonProps) {
  return (
    <button
      type="submit"
      disabled={loading}
      className={cn(
        'flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-3 font-medium text-sm text-white shadow-xs hover:bg-indigo-700 focus:outline-hidden focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50',
        loading && 'cursor-not-allowed',
      )}
    >
      {loading && (
        <svg
          className="mr-3 -ml-8 size-5 animate-spin text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {children}
    </button>
  );
}
